module.exports = __webpack_public_path__ + "static/media/teamsBig.e6900d3c.svg";